// extracted by mini-css-extract-plugin
module.exports = {"ChatBody":"ChatBody_ChatBody__qpARp","MessagesContainer":"ChatBody_MessagesContainer__25G9y","fade":"ChatBody_fade__opDgx"};